export const environment = {
  production: true,
  appTitle: 'Pollo Cheros | Admin',
  stripe_token: 'STRIPE_TOKEN',
  paypal_token: 'PAYPAL_TOKEN',
  loadGif: 'assets/images/loader.gif',
  logo: 'assets/images/Logo_IanOS.png',
  favicon: 'assets/images/favicon.png',
  currency: '',
  default_language: 'es',

  firebase: {
    apiKey: "AIzaSyBuBqcjzBvuf_e2vTF-6pPu4ju9OEbxkQw",
    authDomain: "ianos-app-sv-pollo-king-pro.firebaseapp.com",
    projectId: "ianos-app-sv-pollo-king-pro",
    storageBucket: "ianos-app-sv-pollo-king-pro.firebasestorage.app",
    messagingSenderId: "1043791774183",
    appId: "1:1043791774183:web:ae9d7851abcf4d2784bd42",
    measurementId: "G-XWM0SKZGQ4"
  },
  googleMapsKey: 'AIzaSyDYr_Nesa2FQFrl4at6F4BoGyKVQpRDxBU',
  urlBase: 'https://us-central1-ianos-app-sv-pollo-king-pro.cloudfunctions.net/',
  apikey: '94cd7ea0470-bb20d28f85c65-4b07-4700dd54',
  urlBaseWompy: 'https://us-central1-ianos-app-sv-pollo-king-pro.cloudfunctions.net/Wompi',
  apiBaseUrl: 'https://icivil.ianossolutions.com/v2/ian/productos/',
  apiKeyianos: 'd4ec2cf5bdf-dc7f37bd4cc6a-4eb7-580be2fa',
  dteApiKey: '4f1f0fcced6-d3952dc4788e8-4ea8-7aa56b50',
  dteBaseUrl: 'https://icivil.ianossolutions.com/v2/ian/',
  hasDamagedProducts: false,

  // ── Credenciales opcionales ────────────────────────────────────
  stripe_key: '',           // Llave pública de Stripe (pk_live_...)
  mailchimp: {
    apiKey: '',             // API Key de MailChimp
    server: '',             // Prefijo del servidor (ej: us1)
    listUniqueId: '',       // ID de la lista/audiencia
  },

  // ── Feature flags — indica qué servicios usa este cliente ──────
  // Cambia a true SOLO si la credencial correspondiente está configurada.
  features: {
    saveWithSimilarProducts: false,
    useServerPagination: true, // Paginación de órdenes (false = cliente-side GET, true = servidor-side POST)
    stripe: false,            // Pagos con Stripe (requiere stripe_key real)
    paypal: false,            // Pagos con PayPal (requiere paypal_token real)
    wompi: true,              // Pagos con Wompi (requiere urlBaseWompy)
    dte: true,                // Facturación electrónica DTE (dteApiKey configurado)
    twilio: false,            // SMS / verificación de teléfono vía Twilio
    mailchimp: false,         // Email marketing vía MailChimp (requiere mailchimp.*)
    googleMaps: true,         // Mapas de Google (requiere googleMapsKey)
    membership: false,        // Sistema de membresías
    tableReservations: false, // Módulo de mesas y reservaciones
    kitchen: false,           // Pantalla de cocina
    loyaltyPoints: false,     // Sistema de puntos / tokens
    powertranz: false,          // Verificación PowerTranz (auto-verify + authCode + detalles)
    deliveryNavigation: false,  // Dropdown navegación delivery (Waze / Google Maps)
    invoiceData: false,         // Tabla de datos DTE / factura fiscal
    itemComments: false,        // Mostrar comentarios por ítem en detalle de orden
    bigReportOrder: false      // Reporte Big Order con ticket diario y detalle de ventas
  }
}
